export const communityGuidelinesContent = `
Last Updated: June 7, 2025

The Batesky social network (Batesky App) runs on the Authenticated Transfer Protocol ("AT Protocol"), a decentralized social networking protocol that supports many different kinds of services. These community guidelines have been adapted from the Bluesky Social Community Guidelines.

Our mission is to foster a vibrant and evolving community that respects individual preferences and adapts to the changing needs of our users. These guidelines define how the services we provide may be used.

# Core Principles

- **Empower user choice:** We strive to provide users with the ability to select self-governing services that align with their personal preferences and values. This includes making it easy for users to run their own apps, choose the algorithms that power their feeds, and migrate between services.

- **Cultivate a welcoming environment:** Our aim is to create a safe and friendly space where users feel welcomed, supported, and enjoy participating.

- **Evolve with feedback:** As Batesky grows and evolves, our guidelines and standards will evolve as well. We will regularly review and update these guidelines in response to feedback from our users, emerging trends, and changing circumstances. We strive to maintain transparency about any changes to our policies.

# Batesky Community Guidelines

Our community guidelines are designed to promote a safe and enjoyable experience. To achieve this goal, we may moderate the content on Batesky at our discretion, and you can also adjust content filters within the App according to your preferences in your account settings.

These rules will evolve over time as we continually work to cultivate a healthy and thriving community.

If you come across a user, message, or service that appears to break these guidelines, please report it to us via in-app reporting flows or the in-app feedback form.

## 1. Don't use Batesky to break the law or cause harm to others

For example, do not:

   1. Record or screenshot others inside video cam rooms without their explicit consent  
   2. Praise or promote material from hate groups or proscribed terror groups
   3. Distribute child sexual abuse material, or any content portraying minors in a sexually explicit context
   4. Engage in human trafficking or sexual exploitation, including any attempt to distribute, participate or normalize child sexual abuse
   5. Engage in predatory or inappropriate interactions or exchanges between minors and adults, online or offline. Do not support or normalize pedophilia or the sexual exploitation of minors.
   6. Trade in illegal goods or substances
   7. Steal or distribute others' private personal information without their permission
   8. Hack or access systems that you aren't authorized to access
   9. Scam or cheat others for financial gain
   10. Spam, phish, or otherwise use technical means to disrupt the experience of others on Batesky, or the AT protocol. This includes operating multiple accounts that interact similarly.
   11. Infringe other's copyrights, trademarks and/or other intellectual property
   12. Do not engage in voter suppression or share misleading content about election processes. Do not encourage or glorify the intimidation of election participants or real-world disruption of the election processes.
   13. Do not share misleading content falsely attributed to candidates in elections.
   14. Do not circumvent or evade moderation actions, for example by creating new accounts or repurposing an existing account to replace a banned account, or reposting content that has been removed as part of a moderation enforcement.

## 2. Treat others with respect

For example, no:

   1. Harassment or abuse directed at a specific person or group, including but not limited to, sexual harassment and gender identity-based harassment
   2. Promoting hate or extremist conduct that targets people or groups based on their race, gender, religion, ethnicity, nationality, disability, or sexual orientation
   3. Threats of violence or physical harm, or content that encourages, promotes, or glorifies violence against people, groups, or animals
   4. Encouraging self-harm or suicide
   5. Depictions of excessive violence, gore, torture, dismemberment, or non-consensual sexual activity
   6. Misleading impersonation of other individuals, organizations, or entities

# Reporting

We rely on the entire community (creators, users, visitors) to enforce our community guidelines. The reporting system built into the App and available online or the in-app feedback form helps us detect violations of the Batesky Community Guidelines.

## 1. User Violations of Batesky Community Guidelines

You can report suspected violations of the Community Guidelines by reporting posts, accounts, or direct messages with the in-app reporting feature. We will review reports we receive against these Community Guidelines. Batesky will decide when and how to enforce these Community Guidelines, and if we find a violation of the Guidelines will take enforcement action, which may include restricting a user's ability to use the Batesky App. If your report relies on or relates to conduct that happened outside of Batesky, please provide links, context, or any relevant evidence in the details section of your report, so our moderation team can take these factors into consideration.

We may notify you when we update these guidelines, and by using the Batesky App, you are agreeing to check this page periodically to see changes in the guidelines, which we reserve the right to modify as we see fit. It is up to you to follow the spirit of them: make Batesky a welcoming and empowering place for all users. Thanks for doing your part.
&nbsp;
&nbsp;
&nbsp;
&nbsp;
&nbsp;
&nbsp;
&nbsp;
&nbsp;
`
